<div class="animations-container">
    <router-outlet #o="outlet"></router-outlet>
</div>
<!-- <app-cookie-consent></app-cookie-consent> -->